import React, { useMemo, useState } from 'react';

import useChart from '../../../hooks/useChart';
import { getLineupBarChartOptions } from '../data/chart-lineup';
import ColorLegend from '../ColorLegend';
import LineupPlayerSelector from '../LineupPlayerSelector';
import { teamNameShort } from '../../../lib/format';

const LineupBarChart = ({
  team,
  gameExplorerReport,
  shifts,
  teamColor,
  onTeamShiftClicked,
}) => {
  const [playerSelected, setPlayerSelected] = useState(null);

  const { options, legend, players } = useMemo(
    () =>
      getLineupBarChartOptions(
        gameExplorerReport,
        shifts,
        teamColor,
        playerSelected,
      ),
    [gameExplorerReport, shifts, teamColor, playerSelected],
  );

  const handleShiftClick = ({ componentType, componentSubType, data }) => {
    if (componentType !== 'series' || componentSubType !== 'custom') return;

    onTeamShiftClicked(data.teamShift);
  };

  const domRef = useChart(options, handleShiftClick);

  return (
    <div className="s-game-explorer__lineup-container">
      <div className="s-game-explorer__lineup-legend">
        <h5
          className="s-game-explorer__lineup-legend-team"
          title={team.name}
          style={{ color: teamColor }}
        >
          {teamNameShort(team)}
          <LineupPlayerSelector
            players={players}
            player={playerSelected}
            onPlayerSelected={player => setPlayerSelected(player)}
          />
        </h5>

        <ColorLegend colorLegend={legend} />
      </div>

      <div className="s-game-explorer__lineup" ref={domRef} />
    </div>
  );
};

export default LineupBarChart;
